const accountService = require('services/accountService');
const classService = require('services/classService');
const model = require('model/model');
const userContext = require('core/userContext');
const { closeGCAIframe } = require('utilities');

const getGenericGCAuthURL = (params = new URLSearchParams()) => {
	const gcAddon = model.get('gcAddon');
	const force = !gcAddon && model.get('forceAccountChooser') === true;
	params.set('force', `${force}`);
	if (params.get('url')) {
		// prevent double encoding
		params.set('url', decodeURIComponent(params.get('url')));
	}
	return `/v1/login/google?${params.toString()}`;
};

const generateGoogleClassroomAuthURL = async () => {
	let gcAuthURL = model.get('gcAuthURL');
	const { gcAuthURL: addonAuthURL } = model.get('gcAddon') || {};

	if (addonAuthURL && addonAuthURL !== gcAuthURL) {
		gcAuthURL = addonAuthURL;
		model.set('gcAuthURL', addonAuthURL);
	}

	if (gcAuthURL) {
		return gcAuthURL;
	}

	if (userContext.isStudent()) {
		const activeClass = model.get('activeClass');
		const classCode = activeClass ? activeClass.cc : '';
		const url = getGenericGCAuthURL(
			new URLSearchParams({
				url: '/google-token',
				classCode
			})
		);
		model.set('gcAuthURL', url);
		return url;
	} else if (userContext.loggedIn()) {
		const v = await accountService.getGoogleClassroomAuthURL();
		const url = (v && v.url) || null;
		model.set('gcAuthURL', url);
		return url;
	}
	return '';
};

const authenticateWithGoogleClassroom = () => {
	var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
	var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var w = 500,
		h = 500;

	var left = width / 2 - w / 2 + dualScreenLeft;
	var top = height / 2 - h / 2 + dualScreenTop;

	let newwindow = window.open('', null, 'height=' + h + ',width=' + w + ', top=' + top + ', left=' + left + ', resizable=1, scrollbars=1');

	return generateGoogleClassroomAuthURL().then(url => {
		if (newwindow) {
			newwindow.location.href = url;
		}
		if (window.focus) {
			newwindow.focus();
		}

		return new Promise((resolve, reject) => {
			const onMessage = event => {
				const data = event.data;

				if (event.origin === location.origin && data.name === 'google-addon-return') {
					window.removeEventListener('message', onMessage);

					if (data.success) {
						model.set('localGCAccessToken', data.googleToken);
						resolve(data);
					} else {
						reject(data);
					}
				}
			};

			window.addEventListener('message', onMessage, false);
		});
	});
};

const setGCClassList = async token => {
	if (!token) {
		model.set('gcClassList', undefined);
		return undefined;
	}

	const gcClasses = await classService.listGoogleClassroomClasses({
		token
	});

	model.set(
		'gcClassList',
		gcClasses.map(gcClass => gcClass.id)
	);

	return gcClasses;
};

const isKnownGoogleClass = (gcid = '') => {
	const gcClassList = model.get('gcClassList');

	if (!Array.isArray(gcClassList) || gcClassList.length === 0) {
		return false;
	}

	return gcClassList.includes(gcid);
};

const setGCAddon = () => {
	const urlParams = new URLSearchParams(location.search);
	const paramsToPick = new Set([
		'courseId',
		'itemId',
		'itemType',
		'attachmentId',
		'submissionId',
		'addOnToken',
		'login_hint',
		'hd',
		'initialPath',
		'gcAuthURL'
	]);
	let gcAddon = {};
	let hasKeys = false;

	for (const [param, value] of urlParams.entries()) {
		if (paramsToPick.has(param)) {
			hasKeys = true;
			gcAddon[param] = value;
		}
	}

	if (hasKeys) {
		if (!gcAddon.initialPath) {
			// do not overwrite after forced logout
			gcAddon.initialPath = location.pathname;
		}
		model.set('gcAddon', gcAddon);
	} else if (window.parent === window && !(window.readworks.config.rwtesting && !window.readworks.config.rwUnitTesting)) {
		model.remove('gcAddon');
	}
};

const isInvalidatingGoogleError = error => {
	const invalidatingCodes = new Set([1063, 1093, 1113]);

	return !!error && invalidatingCodes.has(error.code);
};

module.exports = {
	authenticateWithGoogleClassroom,
	getGenericGCAuthURL,
	generateGoogleClassroomAuthURL,
	setGCClassList,
	isKnownGoogleClass,
	setGCAddon,
	closeGCAIframe,
	isInvalidatingGoogleError
};
